import PageLoader from '@/helpers/PageLoader';
import session from '@/services/api/compte/session';

const routesDepot = [
  {
    // TODO: Utiliser PageMapping
    path: '/compte/depot-succes',
    component: PageLoader,
    beforeEnter: (to, from, next) => {
      // Obtention du solde contenu dans la session du joueur
      // TODO: À réviser car OB appelle déjà getSessionDetails (2021-05-27)
      /*
      obtenirSession()
        .then((result) => {
          if (result) {
            next();
          } else {
            next();
          }
        })
        .catch((error) => {
          next();
        });
      */
    },
  },
];

export default routesDepot;
